import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterChangeHandler } from '../../hooks/useFilterChangeHandler';
import { jsx as _jsx } from "react/jsx-runtime";
export function ToggleFilter({
  filter
}) {
  const params = useSearchParams();
  const handleChange = useFilterChangeHandler({
    filter,
    isToggle: true
  });
  if (!filter) return null;
  return /*#__PURE__*/_jsx(Toggle, {
    checked: params.get(filter.field) === 'true',
    id: filter.field,
    onChange: handleChange,
    size: "extra-small"
  });
}